import { Subject } from 'rxjs'
import { Injectable } from '@tanbo/di'

@Injectable()
export class ResizeService {
  /** 显示状态改变发布者 */
  resizeSubject = new Subject()

  constructor () {
    window.addEventListener('resize', () => this.resize())
  }

  resize () {
    setTimeout(() => this.resizeSubject.next())
  }
}
